module.exports = __webpack_public_path__ + "static/media/from-indu.c455de89.jpg";